export const CONFIG_FEATURES = [
    {
        name: 'Metadata',
        path: '/no_job_id/no_output_id/metadata',
        type: 'metadata',
        category: 'metadata',
        target: 'json',
        operation: '',
        dismissable: false,
    },
    {
        name: 'Compare Video',
        path: '/no_job_id/no_output_id/compare-video',
        type: 'compare_video',
        category: 'operation',
        target: 'compare-video',
        operation: '',
        dismissable: false,
    },
    {
        name: 'Compare Image',
        path: '/no_job_id/no_output_id/compare-image',
        type: 'compare_image',
        category: 'operation',
        target: 'compare-image',
        operation: '',
        dismissable: false,
    },
    {
        name: 'Validate PDFA',
        path: '/no_job_id/no_output_id/validate-pdfa',
        type: 'validate_pdfa',
        category: 'operation',
        target: 'validate-pdfa',
        operation: '',
        dismissable: false,
    },
    {
        name: 'Hash',
        path: '/no_job_id/no_output_id/hash',
        type: 'hash',
        category: 'hash',
        target: null,
        operation: '',
        dismissable: false,
    },
];